import { Model } from '@/models/Model';
export class UserFile extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'UserFile';
        this.$endpoint = '/users/{id}/relationships/files';
        this.$fillable = ['file', 'name', 'meta'];
    }
    user(user) {
        if (typeof user !== 'string') {
            user = user.id || '';
        }
        this.$endpoint = `/users/${user}/relationships/files`;
        return this;
    }
    filesEndpoint(userId) {
        this.$endpoint = `/users/${userId}/relationships/files`;
        return this;
    }
    setIdAttribute(id) {
        this.$endpoint = `/users/${this.user}/relationships/files`;
        return id;
    }
    setDeleteEndpoint(user, id) {
        if (typeof user !== 'string') {
            user = user.id || '';
        }
        this.$endpoint = `/users/${user}/relationships/files/${id}`;
        return this;
    }
    createWithACL(file, name, roles) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('name', name);
        roles.forEach((role) => {
            formData.append(`acl[roles][]`, role);
        });
        return this.request('post', this.$endpoint, formData);
    }
    resolvePrimaryKey() {
        return '';
    }
}
